import { NgModule } from '@angular/core';

import { AlertComponent } from './alert.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";

@NgModule({
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        TranslateModule
    ],
    exports: [
        AlertComponent
    ],
    declarations: [AlertComponent],
    providers: [],
})
export class AlertModule { }
